export enum UpsellSlugs {
  Pyridium = 'Pyridium',
  FollowUpUrineTest = 'Follow-Up Urine Test',
  Fluconazole = 'Fluconazole (Yeast Prevention)',
  FluconazoleForBVTreatment = 'Fluconazole (BV)',
  Probiotics = 'Probiotics',
  ShippedProbiotics = 'Shipped Probiotics',
  DoctorsNote = "Doctor's Note",
  Levonorgestrel = 'Levonorgestrel (Plan B)',
  DeliverMedication = 'Delivery',
  OndansetronPill = 'Zofran (Ondansetron) Pill',
  OndansetronDissolvableTablet = 'Zofran (Ondansetron) Dissolvable Tablet',
  MensIntimateWash = 'Mens Intimate Wash',
  MetronidazoleVaginalGel = 'Metronidazole Vaginal Gel .75% (Metrogel)',
  ClindamycinVaginalCream = 'Clindamycin Vaginal Cream 2% (Cleocin)',
  Metronidazole = 'Metronidazole 500mg (Flagyl)',
  ClotrimazoleVaginalCream = 'Clotrimazole Vaginal Cream',
  FollowUpStdTest = 'Follow Up STD Test',
  PartnerTreatment = 'Partner Treatment',
  LidocaineOintment = 'Lidocaine Ointment',
  VitaminDSupplement = 'Vitamin D',
  MetforminExtendedRelease = 'Metformin Extended Release (ER)',
  AcyclovirCreamHSV = 'Acyclovir Cream (HSV)',
  AcyclovirCream = 'Acyclovir Cream',
  VitaminB12Supplement = 'Vitamin B12 Supplement',
  AhWellnessPanel = 'AH Wellness Panel',
  Vasculera = 'Vasculera',
  Glp1Booster = 'GLP-1 Booster',
  OvernightShipping = 'Overnight Shipping',
  SemaglutideInjectable0_5mg = 'Semaglutide Injectable 0.5mg',
  SemaglutideInjectable1mg = 'Semaglutide Injectable 1mg',
  SemaglutideInjectable1_7mg = 'Semaglutide Injectable 1.7mg',
  SemaglutideInjectable2_5mg = 'Semaglutide Injectable 2.5mg',
  SemaglutideOral5mg = 'Semaglutide Oral 5mg',
  SemaglutideOral12mg = 'Semaglutide Oral 12mg',
  TirzepatideInjectable5mg = 'Tirzepatide Injectable 5mg',
  TirzepatideInjectable7_5mg = 'Tirzepatide Injectable 7.5mg',
  TirzepatideInjectable10mg = 'Tirzepatide Injectable 10mg',
  TirzepatideInjectable12_5mg = 'Tirzepatide Injectable 12.5mg',
  TirzepatideInjectable15mg = 'Tirzepatide Injectable 15mg',
  TirzepatideOral4mg = 'Tirzepatide Oral 4mg',
  TirzepatideOral5mg = 'Tirzepatide Oral 5mg',
  Std10TestPanel = 'Starfish 10 Test STD panel',
  MaleBVPartnerTreatment = 'Male BV Partner Treatment',
  ZofranTreatmentDissolvableTabletUpsell = 'Zofran (Ondansetron) Sublingual Dissolvable Tablet',
  RectalCreamAndSuppositoryUpsell = 'Both Lidocaine-Hydrocortisone Rectal Cream and Hydrocortisone Suppository',
  Doxycycline = 'Doxycycline',
  Doxycycline1Treatment = 'DoxyPEP Treatment',
  Doxycycline15Treatments = 'DoxyPEP 15 Treatments Upsell',
  Doxycycline30Treatments = 'DoxyPEP 30 Treatments Upsell Dosage',
  Doxycycline30TreatmentsUpsellFrom15 = 'DoxyPEP 30 Treatments Upsell',
  Doxycycline15TreatmentsStd = 'DoxyPEP 15 Treatments (STD)',
  Doxycycline30TreatmentsStd = 'DoxyPEP 30 Treatments (STD)',
  FiberSupplement = 'Fiber Supplement',
  StoolSoftener = 'Stool Softener',
  PeptideGHKCu = 'GHK-Cu Peptide',
  PeptideCJC1295Ipamorelin = 'CJC-1295/Ipamorelin Peptide',
  PeptideBPC157 = 'BPC-157 Peptide',
  ComprehensiveHealthPanel = 'Comprehensive Health Panel (CBC+CMP+UA+Lipids+Iron+TSH)',
  AhTestosteronePanel = 'AH Testosterone Panel',
  InjectableTrt = 'Injectable TRT',
  TrtAndHcg = 'TRT + hCG',
  TrtAndEnclomiphene = 'TRT + Enclomiphene',
  OralTrtAndEnclomipheneUpsell = 'Oral TRT + Enclomiphene',
  TrtGelAndEnclomipheneUpsell = 'TRT Gel + Enclomiphene',
  TrtGel = 'TRT Gel',
  OralTrt = 'Oral TRT',
  InjectableTrtAndHcgUpsell = 'Injectable TRT + HCG',
  OralFinasteride = 'Oral Finasteride',
  OralMinoxidil = 'Oral Minoxidil',
  TopicalMinoxidil = 'Topical Minoxidil',
  Sildenafil = 'Sildenafil',
  Tadalafil = 'Tadalafil',
  Metformin = 'Metformin IR',
  Biotin = 'Biotin',
  FreeTestosteronePanel = 'Free Testosterone Panel',
  AzelaicAcid = 'Azelaic Acid 15%',
  Spf50Sunscreen = 'SPF 50 External Lotion Sunscreen',
  ZincSupplement = 'Zinc Supplement',
  PriorityProcessing = 'Priority Processing',
  Minoxidil = 'Minoxidil',
  OralAntiInflammatorySkinMedication = 'Oral Anti-Inflammatory Skin Medication',
  AtopiclairBarrierCream = 'Atopiclair Barrier Cream',
  EdGiftcard = 'ED Giftcard',
}
